import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

const ZENDESK_JWT_ENDPOINT = `${URL_ORIGINAL_WEBSITE}/messaging/zendesk/jwt`;

export const loginZendeskMessaging = () => {
  const widget = window.zE;
  if (!widget) {
    return;
  }
  try {
    widget("messenger", "loginUser", async (callback: (jwt: string) => void) => {
      try {
        const response = await fetch(ZENDESK_JWT_ENDPOINT, {credentials: "include"});
        if (!response.ok) {
          throw new Error(`Zendesk JWT endpoint returned ${response.status}`);
        }
        const data: {jwt: string} = await response.json();
        callback(data.jwt);
      } catch (error) {
        console.warn("Zendesk Messaging login failed:", error);
        logoutZendeskMessaging();
      }
    });
  } catch (error) {
    console.warn("Zendesk Messaging login failed:", error);
    logoutZendeskMessaging();
  }
};

export const logoutZendeskMessaging = () => {
  const widget = window.zE;
  if (!widget) {
    return;
  }
  try {
    widget("messenger", "logoutUser");
  } catch (error) {
    console.warn("Zendesk Messaging logout failed:", error);
  }
};

export const openZendeskArticle = (supportLink: string) => {
  if (!supportLink) {
    return;
  }
  window.open(supportLink, "_blank", "noopener,noreferrer");
};

export const zendeskArticleURL = (articleId: string) => {
  return `https://support.uptime.com/hc/en-us/articles/${articleId}`;
};

export const renderZendeskMessengerEmbedded = (targetSelector: string): boolean => {
  const widget = window.zE;
  if (!widget) {
    return false;
  }
  try {
    widget(
      "messenger",
      "render",
      {
        mode: "embedded",
        widget: {targetElement: targetSelector},
      },
      (error: unknown) => {
        if (error) {
          console.warn("Zendesk Messenger render failed:", error);
        }
      }
    );
    return true;
  } catch (error) {
    console.warn("Zendesk Messenger render failed:", error);
    return false;
  }
};

export const openZendeskMessengerWidget = () => {
  const widget = window.zE;
  if (!widget) {
    return;
  }
  try {
    widget("messenger", "open");
  } catch (error) {
    console.warn("Zendesk Messenger open failed:", error);
  }
};

export const closeZendeskMessengerWidget = () => {
  const widget = window.zE;
  if (!widget) {
    return;
  }
  try {
    widget("messenger", "close");
  } catch (error) {
    console.warn("Zendesk Messenger close failed:", error);
  }
};

export const onZendeskMessengerEvent = (event: "open" | "close", callback: () => void): (() => void) => {
  const widget = window.zE;
  if (!widget) {
    return () => {};
  }
  try {
    const unsubscribe = widget("messenger:on", event, callback);
    return typeof unsubscribe === "function" ? (unsubscribe as () => void) : () => {};
  } catch (error) {
    console.warn(`Zendesk Messenger "${event}" subscription failed:`, error);
    return () => {};
  }
};
